<template>
  <!-- <div class="container"> -->
    <p id="about" class="link">Daniel Fernandes - 2020</p>
  <!-- </div> -->
</template>

<script>


export default {
  name: 'Footer',
  components: {
  },
  props: {}
}
</script>


<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap');

  .icon{
    width: auto;
    height: 25px;
    margin-bottom: 15px;
  }
  .link{
    font-family: 'Bebas Neue', cursive;
    text-align: center;
    margin-right: 15px;
    text-decoration: none;
    color: black;
    font-size: 30px;
  }
  .container{
    width: 100%;
    /* display: absolute;
    bottom: 0; */
    align-items: center;
    justify-content: center;
  }
</style>
